var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 562,
    height: 1016,
    viewBox: "0 0 562 1016",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M490 -72L562 -34.2397V76L490 39.1014V-72Z",
    fill: "#023AAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M306 712L378 749.25V858L306 821.6V712Z",
    fill: "#023AAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M479 858L562 898.312V1016L479 976.608V858Z",
    fill: "#023AAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M231 816L283 828.339V891L231 882.29V816Z",
    fill: "#023AAE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 76L154 132.5V399.5L0 350V76Z",
    fill: "#FFB91D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M224 105L306 140.5V279.5L224 251.723V105Z",
    fill: "#FFD765"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBar);
export default __webpack_public_path__ + "static/media/rightBar.f1ba9c6d880c9612192baad38bcbe25c.svg";
export { ForwardRef as ReactComponent };